// import { makeStyles } from '@material-ui/core/styles';

// export default makeStyles(() => ({
//   card: {
//     width : '80%',
//   },
//   cardContent: {
//     height: '17vh', textDecoration: 'none'
//   },
//   grid: {
//     display: 'flex', alignItems: 'center', justifyContent: 'center',margin : '0 auto',
//   },
//   chip: {
//     margin: '5px 5px 5px 0',
//   },
//   subtitle: {
//     display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '10px',
//   },
//   spacing: {
//     display: 'flex', alignItems: 'center', justifyContent: 'space-between',
//   },
// }));

import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  chip: {
    margin: '5px 5px 5px 0',
  },
  subtitle: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '10px',
  },
  spacing: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
  },
}));